export default __webpack_public_path__ + "media/images/mailer-new/welcome/step2-off-768de5803fa4ea77444a03d13fcbb8fb.png";